import gql from 'graphql-tag';
import {
  USER_INFO_FRAGMENT,
  ADDITIONAL_USER_INFO_FRAGMENT,
  GET_USER_POSSIBLE_ENTITIES_INFO_FRAGMENT,
  USER_HEADER_INFO_FRAGMENT,
  USER_COORDONNEES_INFO_FRAGMENT,
  USER_RATTACHEMENT_INFO_FRAGMENT,
  USER_REGIME_IDENTIFIANTS_INFO_FRAGMENT,
} from './fragment';

export const LOGIN = gql`
  mutation LoginAsAdmin($email: String, $phone: String, $password: String!) {
    loginAsAdmin(input: { email: $email, phone: $phone, password: $password })
  }
`;

export const REGENERATE_USER_PASSWORD = gql`
  mutation RegenerateUserPassword($id: Int!) {
    regenerateUserPassword(id: $id)
  }
`;

export const BLOCK_USER = gql`
  mutation BlockUser($id: Int!, $blocked: Boolean!) {
    blockUser(id: $id, blocked: $blocked) {
      id
      blocked
    }
  }
`;

export const SET_USER_MANAGER = gql`
  mutation SetUserManager($input: SetUserManagerInput!) {
    setUserManager(input: $input) {
      id
      isManager
    }
  }
`;

export const SET_USER_MANAGE_ONE_ENTITY = gql`
  mutation SetUserManageOneEntity($input: SetUserManageOneEntityInput!) {
    setUserManageOneEntity(input: $input) {
      ...UserPossibleEntitiesInfo
    }
  }
  ${GET_USER_POSSIBLE_ENTITIES_INFO_FRAGMENT}
`;

export const SET_USER_MANAGED_ENTITIES = gql`
  mutation SetUserManagedEntities($input: SetUserManagedEntitiesInput!) {
    setUserManagedEntities(input: $input) {
      id
      isManager
      entities {
        id
        name
        managers {
          id
        }
      }
    }
  }
`;

export const SET_USER_ENTITIES = gql`
  mutation SetUserEntities($input: SetUserEntitiesInput!) {
    setUserEntities(input: $input) {
      id
      isManager
      entities {
        id
        name
      }
    }
  }
`;

export const ADMIN_EDIT_USER = gql`
  mutation AdminEditUser($input: AdminEditUserInput!) {
    adminEditUser(input: $input) {
      ...UserHeaderInfo
      ...UserCoordonneesInfo
      ...UserRattachementInfo
      ...UserRegimeIdentifiantsInfo
    }
  }
  ${USER_HEADER_INFO_FRAGMENT}
  ${USER_COORDONNEES_INFO_FRAGMENT}
  ${USER_RATTACHEMENT_INFO_FRAGMENT}
  ${USER_REGIME_IDENTIFIANTS_INFO_FRAGMENT}
`;

export const CREATE_NEXT_CLOUD_FOLDER = gql`
  mutation CreateNextCloudFolder($userId: Int!) {
    createNextCloudFolder(userId: $userId) {
      ...UserInfo
      enseigneName
      entities {
        id
        name
      }
    }
  }
  ${USER_INFO_FRAGMENT}
`;

export const CREATE_USER = gql`
  mutation CreateUser($input: CreateUserInput!) {
    createUser(input: $input) {
      ...UserInfo
    }
  }
  ${USER_INFO_FRAGMENT}
`;
